import type { TEmailBuilderActivePanel } from "redux/reducers/emailBuilder/emailBuilder";
import {
  isEmailBuilderTextEditableTarget,
  type IEmailBuilderHistoryHotkeyEvent,
} from "./emailBuilderHistoryHotkeys";

export type TEmailBuilderAddElementsPanelHotkeyAction = "toggle-add-elements";

export function resolveEmailBuilderAddElementsPanelHotkey(
  event: IEmailBuilderHistoryHotkeyEvent,
): TEmailBuilderAddElementsPanelHotkeyAction | null {
  if (isEmailBuilderTextEditableTarget(event.target)) {
    return null;
  }

  const key = event.key.toLowerCase();
  const modifierPressed = event.metaKey || event.ctrlKey;

  if (key === "/" && !modifierPressed && !event.shiftKey && event.altKey !== true) {
    return "toggle-add-elements";
  }

  if (modifierPressed && event.shiftKey && key === "a" && event.altKey !== true) {
    return "toggle-add-elements";
  }

  return null;
}

export function emailBuilderAddElementsPanelAfterHotkey(
  activePanel: TEmailBuilderActivePanel,
): TEmailBuilderActivePanel {
  return activePanel === "add-elements" ? "none" : "add-elements";
}
